import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import Button from './Button'

import './ConfirmationOverlay/index.scss'

const DeleteConfirmationOverlay = ({ message, subMessage, onConfirm, onCancel }: any) => (
  <div className="confirmation__overlay">
    <div className="confirmation__box">
      <p className="confirmation__message">{message}</p>
      {!!subMessage && <p className="confirmation__sub_message">{subMessage}</p>}

      <div className="confirmation__actionblock">
        <Button color="secondary" onClick={onCancel}>
          <FormattedMessage id="Cancel" defaultMessage="Cancel" />
        </Button>

        <Button color="warning" onClick={onConfirm}>
          <FormattedMessage id="Delete" defaultMessage="Delete" />
        </Button>
      </div>
    </div>
  </div>
)

DeleteConfirmationOverlay.displayName = 'DeleteConfirmationOverlay'

DeleteConfirmationOverlay.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  subMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
}

DeleteConfirmationOverlay.defaultProps = {
  message: 'Are you sure?',
  subMessage: ''
}

export default DeleteConfirmationOverlay
